import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import { enGlobal } from "./en/enGlobal";

/**
 * Bundle-split strategy:
 *   - English ships in the main bundle (default + fallback).
 *   - Spanish is lazy-loaded only when the detected/selected language is 'es'.
 *   - Switching to 'es' at runtime triggers a one-time dynamic import.
 */
const resources = {
  en: { translation: enGlobal },
};

const loadSpanish = () =>
  import(/* webpackChunkName: "locale-es" */ "./es/esGlobal").then(({ esGlobal }) => {
    if (!i18n.hasResourceBundle("es", "translation")) {
      i18n.addResourceBundle("es", "translation", esGlobal, true, true);
    }
  });

i18n
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["en", "es"],
    interpolation: { escapeValue: false },
    partialBundledLanguages: true,
  })
  .then(() => {
    const lng = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];
    if (lng === "es") return loadSpanish().then(() => i18n.changeLanguage("es"));
    return undefined;
  });

// Intercept future language switches so 'es' is fetched on demand.
i18n.on("languageChanged", (lng) => {
  const base = (lng || "").split("-")[0];
  if (base === "es" && !i18n.hasResourceBundle("es", "translation")) {
    loadSpanish();
  }
});

export default i18n;
